import { OnboardingGenericTaskType } from '@tiendanube/common';
import generateConfidenceImg from './promoto-thumb-confidence.png';
import improveConversionImg from './promoto-thumb-conversion.png';
import increaseTrafficImg from './promoto-thumb-traffic.png';

export const getPandaThumbnail = (
  task: OnboardingGenericTaskType,
): string | undefined => {
  const thumbnailMap: Partial<Record<OnboardingGenericTaskType, string>> = {
    generate_confidence_video: generateConfidenceImg,
    increase_traffic_video: increaseTrafficImg,
    improve_conversion_video: improveConversionImg,
  };

  return thumbnailMap[task];
};
